module.exports = __webpack_public_path__ + "img/a7c975f.jpg";